import React from 'react'

export const NotFound = () => {
    return (
        <div>
            <h1>Not Found</h1>
            <p className="lead">Page doesn't exist</p>
        </div>
    )
}
